<template>
  <v-container>
    <v-card-title class="pl-0 pb-2">
      Permissions
    </v-card-title>
    <v-card
      v-for="(role, index) in modelValue"
      :key="index"
      class="mb-4 pa-4"
    >
      <v-card-title class="d-flex justify-space-between align-center">
      <span>Role {{ index + 1 }}</span>
      <v-btn :disabled="readOnly" aria-label="remove role" icon variant="text" @click="removeRow(index)">
        <v-icon color="red">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

      <v-row dense>
          <v-col
            v-for="(key) in filteredEntries(role)"
            :key="key"
            cols="12"
            md="6"
      >
      
      
          <v-select
            :model-value="role[key]"
            @update:modelValue="val => updateRoleValue(key, val, index)"
            :items="getOptionsForKey(key, index)"
            :label="formatLabel(key)"
            variant="outlined"
            density="compact"
            item-title="label"
            item-value="value"
            :readonly="readOnly"
          />
        </v-col>
        
      </v-row>
    </v-card>
    <v-btn :disabled="readOnly" aria-label="add role"
      color="primary" @click="addRow">
    <v-icon left>mdi-plus</v-icon> Add Role
  </v-btn>
  </v-container>
</template>

<script setup>
import { computed , ref, inject} from 'vue'
import {subsystemUrls} from '@/config'
import { useUserStore } from '@/store/user'
import { usePathController } from '@/composables/usePathController'
import { useLoaderStore } from "@/store/loader"
import {entityRegistry} from "@/config/entityRegistry"
import {useLogger} from "@/composables/useLogger"


const userStore = useUserStore()
const selectedProfile = inject("entityState")
const removeEntityField = inject("removeEntityField")
const loader = useLoaderStore()
const disableFormSubmission = inject('toggleSubmit')
// const emit = defineEmits(["update:modelValue"])

const readOnly = computed(() => userStore.userId === selectedProfile?._id && !userStore.isSysAdmin)
// const readOnly = computed(true)
console.log("log computed value", {
  isSelf: userStore.userId === selectedProfile?._id, 
  isAdmin: userStore.isSysAdmin
})
function updateRoleValue(key, val, index){
  if(key === "accessLevel"){
    const {sendLog} = useLogger()

    const {company = null, department = null, organisation = null} = selectedProfile
    const selectedSubsystemAccess = props.modelValue[index].subsystemAccess || null
    const validationMap = entityRegistry.users.validation[selectedSubsystemAccess]?.roles(selectedProfile) || null
    sendLog("debug", "handle_role_update", {
      key, val, validationMap, hasEntity: validationMap?.[val].hasEntity
    })
    const entityType = validationMap?.[val].entityType

    const {typename = null, entityPath = null, id = null} = selectedProfile?.roles_metadata ?? {}
    removeEntityField("roles_metadata")
    disableFormSubmission(false)
    if(validationMap && validationMap[val].hasEntity){
      props.modelValue[index][key] = val
      props.modelValue[index].entityType = validationMap[val].entityType || typename
      props.modelValue[index].priority = validationMap[val].priority 
      props.modelValue[index].entityPath = validationMap[val].entityPath || entityPath || selectedProfile?.pathPrefix
      props.modelValue[index].entityId = validationMap[val].entityId || id || selectedProfile?.[entityType]
      }
    else if(validationMap === null){
      props.modelValue[index][key] = val
    }
    else {
      props.modelValue[index][key] = ""
      loader.setAlert({
        message: validationMap[val].errorMessage, 
        timeout: 5000, 
        type: 'error' }
      );
    }
  }
  else {
    props.modelValue[index][key] = val
    }
  }

const props = defineProps({
  modelValue: {
    type: Array,
    required:true
  }
})
  
function addRow() {
  const topPriority = props.modelValue?.length ? props.modelValue[0] : null
  props.modelValue.push({
    accessLevel: '',
    entityType: "",
    subsystemAccess: '',
    entityId: topPriority? topPriority.entityId : null,
    priority: topPriority? topPriority.priority : 4,
    entityPath: topPriority? topPriority.entityPath : ""
  })
}

function removeRow(index) {
  props.modelValue.splice(index, 1)
}

const fieldOrder = ['subsystemAccess', 'accessLevel']

function filteredEntries(role) {
  const hideKeys = ['__typename', "entityId", "priority", "entityPath", "entityType"]
 const final = fieldOrder.filter(k => k in role && !hideKeys.includes(k))
 return final
}

function filterAccessLevel(key, index){ 
  const chosenSubsystem = props.modelValue[index]["subsystemAccess"]
  let filtered
  if(chosenSubsystem === "clarity") {
    const completedAccessLevel =  [
        { label: 'User', value: 'User' },
        { label: 'Supervisor', value: 'Supervisor' },
        { label: 'CompanyAdmin', value: 'CompanyAdmin' },
        { label: 'OrganisationAdmin', value: 'OrganisationAdmin' },
        { label: 'SysAdmin', value: 'SysAdmin' },
      ];
  
    const indexToStop = {
      "CompanyAdmin": 2,
      "OrganisationAdmin": 3,
      "SysAdmin": completedAccessLevel?.length
    }
    filtered = completedAccessLevel.slice(0,indexToStop[userStore.accesslevel])
  }
  else {
    const completedAccessLevel =  [
        { label: 'Company', value: 'Company' },
        { label: 'Department', value: 'Department' },
        { label: 'Update', value: 'Update' },
      ];
    filtered = completedAccessLevel
  }

  return filtered
}



function getOptionsForKey(key, index) {
  switch (key) {
    case 'subsystemAccess':
      return Object.keys(subsystemUrls).map(key => ({label: key, value: key}))
    case 'accessLevel':
      return filterAccessLevel(key,index)
    default:
      return [];
  }
}

// optional: nicer labels
function formatLabel(key) {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
}
</script>